var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.enabled)?_c('div',{staticClass:"cf-turnstile",attrs:{"id":_vm.uniqueId,"data-sitekey":_vm.siteKey}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }